import paths from '../paths';
import { KisaanClient } from './axiosKisaanClient';

interface SeoUrlPayload {
  id: string | number;
  type: string;
}

interface SeoUrlResponse {
  url: string;
}

export const getSeoUrl = async (payload: SeoUrlPayload): Promise<SeoUrlResponse> => {
  try {
    // const formattedPayload = {
    //     id: String(payload.id),
    //     type: String(payload.type),
    // };
    // const response = await KisaanClient.post<SeoUrlResponse>(paths.getVideoSeoUrl(), formattedPayload);
    let url;

    if (payload?.type === 'Stream') {
      url = `${process.env.WEB_APP_URL}/longVideo/${payload.id}`;
    } else if (payload?.type === 'Qna') {
      url = `${process.env.WEB_APP_URL}/questionDetailList/${payload.id}`;
    }
    const response = {
      data: {
        url: url,
      },
    };

    return response.data;
  } catch (e) {
    throw e;
  }
};

export const getSeoUrlWeb = async (payload: SeoUrlPayload): Promise<any> => {
  try {
    const formattedPayload = {
      id: String(payload.id),
      type: String(payload.type),
    };

    const url = `${process.env.APP_KISAN_URI}/kisaan/video-conversion/p/seo-friendly-url`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedPayload),
    });

    const seoUrl = await response.json();
    return getLastSegment(seoUrl?.url) ?? '';
  } catch (error) {
    console.error('getSeoUrlWeb fetch error:', error);
    return null;
  }
};

const getLastSegment = (url: string): string => {
  const lastSegment = url?.split('/')?.filter(Boolean).pop() || '';
  return lastSegment;
};
